/* Ayudate · Días, horas y disponibilidad */


import { precioDe } from "./tarifas";
import { verificacionDe } from "../datos/areas";

/* Lunes a domingo. El índice coincide con Date.getDay(): 0 = domingo. */
export const DIAS = [
  { k: 1, lb: "LUN" }, { k: 2, lb: "MAR" }, { k: 3, lb: "MIÉ" }, { k: 4, lb: "JUE" },
  { k: 5, lb: "VIE" }, { k: 6, lb: "SÁB" }, { k: 0, lb: "DOM" },
];

/* Bloques de una hora, de 8:00 a 23:00. */
export const HORAS = Array.from({ length: 16 }, (_, i) => i + 8);
export const hLabel = (h) => `${h}:00`;

/* Nada se reserva dentro de las próximas 24 horas: entre que se pide y que
   empieza tienen que caber la confirmación del tutor y el pago del
   estudiante (ver CONFIG.horasParaConfirmar y sinpe.horasParaPagar en
   apps-script.gs). Agenda.jsx redondea este margen hacia arriba a la hora en
   punto siguiente antes de aplicarlo. */
export const HORAS_MINIMAS = 24;

/* Tampoco se puede reservar con más de un mes de anticipación — mismo tope
   que revalida crearSolicitud() en apps-script.gs (CONFIG.diasMaximoReserva). */
export const DIAS_MAXIMO_RESERVA = 30;

export const FRANJAS = [
  { id: "mañana", label: "Mañana" }, { id: "tarde", label: "Tarde" },
  { id: "noche", label: "Noche" }, { id: "fines", label: "Fin de semana" },
];

/* Las tutorías son estrictamente virtuales: no hay opción presencial. Un
   bloque de la grilla solo tiene dos estados, no una lista de modalidades. */
export const MODOS = [
  { id: "virtual", ini: "V", lb: "Virtual" },
];

export const NIVELES = [
  { id: "A1", d: "Principiante" }, { id: "A2", d: "Básico" },
  { id: "B1", d: "Intermedio" }, { id: "B2", d: "Intermedio alto" },
  { id: "C1", d: "Avanzado" }, { id: "C2", d: "Dominio" },
];

/* Para registrarse como tutor de idiomas pedimos B2 o más: dar clases con
   un nivel intermedio o básico no da la seguridad de dominio que necesita
   quien enseña. NIVELES completo (A1 a C2) sigue existiendo para lo que
   describe el nivel que un estudiante ya tiene o busca, no para filtrar
   quién puede dar tutorías. */
export const NIVELES_TUTOR = NIVELES.filter((n) => ["B2", "C1", "C2"].includes(n.id));

/* En software lo que se declara es cuánto se domina la herramienta, en la
   misma escala en que se piensa un programa: básico, intermedio, avanzado.
   No es la escala del CURSO sino la de quien enseña — que la tutoría sea de
   Excel · Básico no dice nada de cuánto sabe quien la da, y al revés. */
export const NIVELES_SOFTWARE_TUTOR = [
  { id: "Básico", d: "Maneja lo esencial de la herramienta" },
  { id: "Intermedio", d: "La usa con soltura en trabajos propios" },
  { id: "Avanzado", d: "Uso profesional o certificado" },
];

/* Con qué respalda su capacidad quien se registra para dar un curso. Cada
   institución elige su escala con el campo `verificacion` (ver
   datos/areas.js); la que no declara ninguna cae en "nota", la nota de
   expediente de siempre. Hay dos formas:

     · escala de opciones (`niveles`) → un <select> con lo que acepta;
     · escala numérica (`min`/`max`) → un campo que solo admite dígitos y
       avisa en el acto si el número se sale del rango.

   Todo lo que cambia entre una y otra vive acá —la etiqueta del campo, el
   texto del comprobante, cómo se nombra el dato cuando falta— para que el
   formulario de registro (FormTutor.jsx) y el de "agregar curso" del panel
   (DashboardTutor.jsx) no escriban cada uno su propia copia ni su propio
   rango. Antes los dos llevaban el 80–100 a mano y decían "Su nota" en
   duro; agregar la nota de admisión, que va de 0 a 900, habría sido
   escribir la tercera y la cuarta copia. */
export const ESCALAS_NIVEL = {
  nota: {
    etiqueta: "Su nota",
    deQue: "su nota",
    min: 80, max: 100,
    fuera: "La nota debe ser un número entre 80 y 100.",
    falta: "la nota (un número entre 80 y 100)",
    comprobante: "Captura o foto del expediente donde se vea una nota entre 80 y 100.",
  },
  cefr: {
    etiqueta: "Su nivel",
    deQue: "su nivel",
    niveles: NIVELES_TUTOR,
    fuera: "", falta: "el nivel",
    comprobante: "Certificado de su nivel de idioma (mínimo B2).",
  },
  software: {
    etiqueta: "Nivel de conocimiento",
    deQue: "su nivel de conocimiento",
    niveles: NIVELES_SOFTWARE_TUTOR,
    fuera: "", falta: "el nivel de conocimiento",
    comprobante: "Certificado, diploma o constancia laboral que respalde su nivel en la herramienta.",
  },
  /* Admisión no tiene expediente con nota de curso ni certificado de nivel:
     lo que respalda a quien prepara el examen es la nota que él mismo sacó,
     en la escala de 200 a 800 del TEC/UCR. El rango va de 0 a 900 —
     deliberadamente más ancho que el real— para no dejar afuera a nadie por
     una escala que cambie o por otra universidad. */
  examadm: {
    etiqueta: "Su nota de admisión",
    deQue: "su nota de admisión",
    min: 0, max: 900,
    fuera: "La nota de admisión debe ser un número entre 0 y 900.",
    falta: "la nota de admisión (un número entre 0 y 900)",
    comprobante: "Captura o foto del resultado oficial del examen de admisión, donde se vea su nota.",
  },
  /* Colegio es la única escala que no pide nada: ni nota ni comprobante.
     Materia de sétimo a undécimo no tiene expediente universitario que
     capturar ni certificado que emita nadie, y exigir uno solo dejaba fuera
     a quien sí puede dar la tutoría. `sinRequisito` lo dice explícito para
     que los dos formularios (FormTutor.jsx y el "agregar curso" de
     DashboardTutor.jsx) escondan los dos campos y no los validen, en vez de
     que cada uno adivine por el id de la escala. La revisión no desaparece:
     el perfil sigue entrando "pendiente" y no se publica hasta que un
     administrador lo apruebe. */
  colegio: {
    sinRequisito: true,
    etiqueta: "", deQue: "", falta: "", fuera: "", comprobante: "",
  },
};

/* Si esta escala pide respaldo. La única que no es "colegio"; todo lo demás
   —nota de expediente, nivel de idioma, nivel de software, nota de
   admisión— pide su dato y su comprobante. */
export const pideRespaldo = (escala) => !escala?.sinRequisito;

/* La escala que le toca a un curso. Nunca devuelve nulo: sin `verificacion`
   declarada, la nota de expediente. */
export const escalaDeCurso = (cod) => ESCALAS_NIVEL[verificacionDe(cod)] || ESCALAS_NIVEL.nota;
export const escalaDeInstitucion = (inst) => ESCALAS_NIVEL[inst?.verificacion] || ESCALAS_NIVEL.nota;

/* Una escala es de opciones o es numérica; el resto del código pregunta por
   esto, no por el id de la escala. */
export const esDeOpciones = (escala) => Array.isArray(escala?.niveles);

/* Lo que se deja escribir en un campo de escala numérica: dígitos y nada
   más. Ni letras, ni signos, ni el "e" o el "-" que <input type="number">
   deja colar sin que el valor se pueda siquiera leer para corregirlo (con
   type="number", un "12e" llega al onChange como "" y no hay qué limpiar).
   Se corta una cifra más allá del tope de la escala: lo suficiente para que
   quien escriba 1000 en un campo de 0 a 900 VEA su 1000 y el aviso de que
   se pasó, en vez de que el campo le recorte el número por lo bajo y se lo
   dé por bueno; y lo bastante corto para que un dedo pegado no deje veinte
   cifras adentro. */
export const soloDigitos = (v, escala) =>
  String(v ?? "").replace(/\D/g, "").slice(0, String(escala?.max ?? 999).length + 1);

/* Si el valor escrito se sale del rango. Vacío no está "fuera": todavía no
   escribieron nada, y eso lo reporta el "falta" de cada escala. */
export const fueraDeEscala = (escala, v) => {
  if (esDeOpciones(escala) || v === undefined || v === null || v === "") return false;
  const n = Number(v);
  return Number.isNaN(n) || n < escala.min || n > escala.max;
};

/* Si el dato está completo y es válido para su escala. Una escala sin
   requisito (Colegios) no tiene dato que completar: siempre está lista. */
export const valorDeEscalaOk = (escala, v) => (!pideRespaldo(escala) ? true
  : esDeOpciones(escala)
    ? escala.niveles.some((n) => n.id === v)
    : v !== undefined && v !== null && String(v) !== "" && !fueraDeEscala(escala, v));

/* Año de carrera que cursa el tutor, para mostrarlo en su tarjeta pública. */
export const ANIOS_TUTOR = ["I Año", "II Año", "III Año", "IV Año", "V Año", "Egresado"];

/* Las franjas se DERIVAN de la grilla: la disponibilidad es la única fuente de
   verdad. Guardarlas aparte dejaba a los tutores nuevos fuera de los filtros. */
export const franjasDe = (disp = {}) => {
  const out = new Set();
  Object.keys(disp).forEach((k) => {
    const [dia, hora] = k.split("-").map(Number);
    if (dia === 0 || dia === 6) out.add("fines");
    if (hora >= 8 && hora <= 12) out.add("mañana");
    else if (hora >= 13 && hora <= 17) out.add("tarde");
    else if (hora >= 18) out.add("noche");
  });
  return [...out];
};

/* Cada curso de un tutor es una oferta propia: su precio, su descripción y su
   tarjeta. Alguien que da tres niveles de inglés no cobra lo mismo en los tres.
   Tampoco comparten estado de publicación: retirar o pausar un curso puntual
   no debe afectar a los otros cursos aprobados del mismo tutor, así que
   estado/publicado se leen de estadosPorCurso/publicadosPorCurso (por FILA),
   nunca del valor único a nivel de tutor.
   La calificación y la cantidad de sesiones tampoco son iguales en los tres:
   cada curso trae las suyas en statsPorCurso; si un tutor todavía no las tiene
   desglosadas (p.ej. viene de la hoja sin ese dato), se usa la del tutor.
   La fecha de creación sigue la misma regla: la que vale para una tarjeta es
   la del día en que se creó ESA oferta (creadosPorCurso), no la del registro
   del tutor — quien agregó un curso este mes no arrastra a esa tarjeta nueva
   la antigüedad de la que abrió el año pasado. Es lo que desempata a dos
   tarjetas con el mismo peso (ver masAntiguoPrimero en lib/orden.js). */
export const expandirOfertas = (tutores) => tutores.flatMap((t) =>
  (t.cursos || []).map((c) => {
    const stats = (t.statsPorCurso || {})[c];
    return {
      ...t,
      ofertaId: `${t.id}::${c}`,
      curso: c,
      cursos: [c],
      bio: (t.descripciones && t.descripciones[c]) || t.bio,
      nivel: (t.notas && t.notas[c]) || null,
      estado: (t.estadosPorCurso && t.estadosPorCurso[c]) || t.estado,
      publicado: (t.publicadosPorCurso && t.publicadosPorCurso[c]) || t.publicado,
      rating: stats ? stats.rating : (t.rating ?? null),
      resenas: stats ? stats.resenas : (t.resenas ?? 0),
      sesiones: stats ? stats.sesiones : (t.sesiones ?? 0),
      creado: (t.creadosPorCurso || {})[c] || t.creado || null,
      tarifaCliente: precioDe((t.tarifasPorCurso || {})[c] ?? t.tarifaBase).cliente,
      tarifaTutor: precioDe((t.tarifasPorCurso || {})[c] ?? t.tarifaBase).tutor,
    };
  }));
